export default "/_next/static/chunks/fonts/pxiByp8kv8JHgFVrLCz7Z1xlFQ-c42d83a607aac6b2d4225ae46ea33599.woff2";